
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.706 1.39h-2.984C18.774.544 16.988.023 15 .023c-1.988 0-3.774.52-4.723 1.367H7.294C3.272 1.39 0 4.662 0 8.684c0 4.021 3.272 7.293 7.294 7.293 4.021 0 7.293-3.272 7.293-7.293 0-.054 0-.107-.002-.16h.83a6.56 6.56 0 00-.002.16c0 4.021 3.272 7.293 7.293 7.293 4.022 0 7.294-3.272 7.294-7.293 0-4.022-3.272-7.294-7.294-7.294zM7.294 13.011a4.333 4.333 0 01-4.328-4.327 4.333 4.333 0 014.328-4.328 4.333 4.333 0 014.327 4.328 4.333 4.333 0 01-4.327 4.327zm9.666-8.796h-3.921a.845.845 0 010-1.69h3.92a.845.845 0 010 1.69zm5.746 8.796a4.333 4.333 0 01-4.328-4.327 4.333 4.333 0 014.328-4.328 4.333 4.333 0 014.328 4.328 4.333 4.333 0 01-4.328 4.327z","fill":"#D8F3DC"}})])
          )
        }
      }
    